import { gl } from "../../../../date-fns/locale/gl.js";
window.dateFns = {
  ...window.dateFns,
  locale: {
    ...window.dateFns?.locale,
    gl
  }
};